import { IconProps } from '../types';

export const FilledWarningIcon = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={19} fill="none" {...props}>
    <path
      fill="#D92D20"
      d="m11.865 1 9.526 16.5a1 1 0 0 1-.866 1.5H1.473a1 1 0 0 1-.866-1.5L10.133 1a1 1 0 0 1 1.732 0ZM9.999 14v2h2v-2h-2Zm0-7v5h2V7h-2Z"
    />
  </svg>
);
